import { cn } from '@/utils/tailwind';

export const LayoutReviewsBody = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('flex w-full flex-col gap-4 pr-[12px]', className)}>{children}</div>;
};
